import { createContext } from 'react';
import { type PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';

export const PaymentProviderContext = createContext<PaymentProvider>(null);
